import React, { useEffect, useState, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axiosInstance from '../../axios';
import { Container, Row, Col, Alert, Spinner, Button, Carousel } from 'react-bootstrap';
import { HiArrowLeft, HiArrowRight } from 'react-icons/hi';
import './PropertyDetail.css';

const PropertyDetail = () => {
  const { identifier } = useParams();
  const navigate = useNavigate();
  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axiosInstance.get(`/properties/${identifier}`);
        setProperty(res.data?.data || null);
      } catch (e) {
        console.error(e);
        setError('Gagal memuat data properti.');
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [identifier]);

  const images = useMemo(() => property?.images?.map(i => i.display_image_url) || [], [property]);
  const primary = useMemo(() => property?.main_image_url || property?.image_url, [property]);

  if (loading) {
    return (
      <Container className="py-5 text-center">
        <Spinner animation="border" variant="primary" />
      </Container>
    );
  }

  if (error || !property) {
    return (
      <Container className="py-5">
        <Alert variant="danger">{error || 'Properti tidak ditemukan.'}</Alert>
        <Button variant="secondary" onClick={() => navigate(-1)}><HiArrowLeft size={16} /> Kembali</Button>
      </Container>
    );
  }

  return (
    <Container className="property-detail-page py-4">
      <Button variant="outline-primary" className="mb-3" onClick={() => navigate(-1)}><HiArrowLeft size={16} /> Kembali</Button>
      {/* Hero / carousel */}
      {images.length > 0 ? (
        <Carousel className="mb-4">
          {images.map((src, idx) => (
            <Carousel.Item key={idx}>
              <img className="d-block w-100" src={src} alt={`Gambar ${idx + 1}`} />
            </Carousel.Item>
          ))}
        </Carousel>
      ) : (
        <img src={primary} alt={property.title} className="w-100 rounded mb-4" />
      )}

      <Row className="mb-3">
        <Col md={8}>
          <h2>{property.title}</h2>
          <h3 className="text-primary">{property.price_format}</h3>
        </Col>
        <Col md={4} className="text-md-end">
          <span className="badge bg-success">{property.status_label}</span>
        </Col>
      </Row>

      {/* Description */}
      <Row className="mb-4">
        <Col>
          <div dangerouslySetInnerHTML={{ __html: property.description || '' }} />
        </Col>
      </Row>

      {/* Info grid */}
      <Row className="g-3 mb-4">
        <Col md={6} lg={4}><div className="detail-card p-3"><strong>Lokasi</strong><p>{property.location}</p></div></Col>
        <Col md={6} lg={4}><div className="detail-card p-3"><strong>Luas Bangunan</strong><p>{property.building_area} m²</p></div></Col>
        <Col md={6} lg={4}><div className="detail-card p-3"><strong>Luas Tanah</strong><p>{property.land_area} m²</p></div></Col>
        <Col md={6} lg={4}><div className="detail-card p-3"><strong>Kamar Tidur</strong><p>{property.bedrooms ?? '-'}</p></div></Col>
        <Col md={6} lg={4}><div className="detail-card p-3"><strong>Kamar Mandi</strong><p>{property.bathrooms ?? '-'}</p></div></Col>
        <Col md={6} lg={4}><div className="detail-card p-3"><strong>Status</strong><p>{property.status_label}</p></div></Col>
      </Row>

      {/* Features */}
      {property.features?.length > 0 && (
        <Row className="mb-4">
          <Col>
            <h5>Fitur</h5>
            <ul className="list-unstyled d-flex flex-wrap">
              {property.features.map(f => (
                <li key={f.id} className="badge bg-light text-dark me-2 mb-2" style={{fontSize:'0.9rem'}}>{f.name}</li>
              ))}
            </ul>
          </Col>
        </Row>
      )}

      {/* Action buttons */}
      <Row className="mt-4">
        <Col className="d-flex justify-content-between">
          <Button variant="outline-primary" onClick={() => navigate('/dashboard')}>Kembali ke Dashboard</Button>
          <Button variant="primary" onClick={() => navigate(`/dashboard/properties/${identifier}/edit`)}>
            Edit Properti <HiArrowRight size={16} />
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default PropertyDetail;
